exports.JSON_DATE_FORMAT = 'YYYY-MM-DD HH:mm';
exports.JWT_LOCALSTORAGE_KEY = 'jwt';
exports.REFERRER_LOCALSTORAGE_KEY = 'referrer';
